import { gettext } from '@eventbrite/i18n';
import notificationsHelperFactory from '../../helpers/notifications-helper';
import {
    STATUS_AVAILABLE,
    STATUS_PROTECTED,
} from '../../constants/status-constants';

const manageDashboardManagerFactory = ({ model }) => {
    const aInit = async () => null;

    const mouseDown = () => null;
    const mouseUp = () => null;
    const mouseMove = () => null;
    const cancel = () => null;

    const notifications = notificationsHelperFactory({
        model,
        path: 'manage.notifications',
    });

    notifications.set({
        id: 'shiftMsg',
        msg: gettext(
            'You can select multiple seats at the same time by holding the SHIFT key',
        ),
        type: 'info',
        onClose: () => true,
    });

    const getNotifications = () => notifications.get();

    const getRowsFromId = (id) => {
        const rows = [];

        if (model.get(`objects.contents.${id}.chairs`)) {
            const paths = id.split('.');
            const lastId = paths[paths.length - 1];

            rows.push(lastId);
        }
        const contents = model.get(`objects.contents.${id}.contents`);

        if (contents) {
            Object.keys(contents).forEach((key) => {
                const childKey = `${id}.contents.${key}`;
                const childResults = getRowsFromId(childKey);

                for (let i = 0; i < childResults.length; i++) {
                    const childId = childResults[i];

                    rows.push(childId);
                }
            });
        }
        return rows;
    };

    const getAvailabilityFromRows = (rows) => {
        const status = model.get('status') || {};
        const availability = rows.reduce(
            (availability, key) => {
                const { total, available } = availability;
                let rowTotal = 0;
                let rowAvailable = 0;
                const record = status[key] || {};
                const s = record.s || [];

                for (let i = 0; i < s.length; i++) {
                    const seatStatus = s[i];

                    if (seatStatus) {
                        rowTotal++;
                        switch (seatStatus) {
                            case STATUS_AVAILABLE:
                            case STATUS_PROTECTED:
                                rowAvailable++;
                                break;
                            default:
                        }
                    }
                }
                return {
                    total: total + rowTotal,
                    available: available + rowAvailable,
                };
            },
            { total: 0, available: 0 },
        );

        return availability;
    };

    const getReservedSectionTotalUnitsInfo = (sectionId) => {
        const totalsUnitsInfo = {
            available: 0,
            total: 0,
            holds: 0,
            sold: 0,
        };
        const rows = getRowsFromId(sectionId);

        if (rows && rows.length) {
            const { available: totalUnitsAvailable, total: totalUnits } =
                getAvailabilityFromRows(rows);

            totalsUnitsInfo.available = totalUnitsAvailable;
            totalsUnitsInfo.total = totalUnits;
        }

        return totalsUnitsInfo;
    };

    const getHoverSectionInfo = () => {
        const hoverObject = model.get('globals.hoverObject');
        const hoverId = model.get('globals.hoverId');

        if (hoverObject) {
            const obj = model.get(`objects.contents.${hoverObject}`);

            if (obj && obj.properties) {
                return {
                    hoverSectionTitle: obj.properties.l,
                    hoverSectionId: hoverObject,
                    seatId: hoverId,
                };
            }
        }
        return null;
    };

    return {
        interactive: {
            mouseDown,
            mouseUp,
            mouseMove,
            cancel,
        },
        getHoverSectionInfo,
        getNotifications,
        getReservedSectionTotalUnitsInfo,
        aInit,
    };
};

export default manageDashboardManagerFactory;
